<style lang="scss" scoped>
.token {
	&__code {
		word-break: break-word;
		background: #eee;
		display: block;
		padding: 10px;
		border-radius: 5px;
		margin-bottom: 30px;
	}
}
</style>

<template lang="pug">
    .token 
        code.token__code {{ token }}
        el-button(@click="copyToken()", type="primary", icon="fa fa-copy") Copy to clipboard
        el-button(@click="$vuedals.close()") Close
</template>

<script>
import { copy } from "@/libraries/clipboard.lib";

export default {
	name: "ShowTokenModal",
	props: {
		token: {
			type: String,
			required: true
		}
	},
	methods: {
		copyToken() {
			copy(this.token);
			this.$message.success("Copied to your clipboard");
		}
	}
};
</script>
